import type { Airflow } from '@aviata/platform-types';

export const getMedicalInsurancePrice = (
  productsList: Airflow.Order.Entity['products'],
) => {
  const roamingProducts = productsList.filter(
    product => product.type === 'products.medical-insurance',
  );

  if (roamingProducts.length === 0) {
    return null;
  }

  return roamingProducts.reduce(
    (acc, product) => acc + Number(product?.total),
    0,
  );
};
